import React, {useState} from 'react';
import {Button, Card, Checkbox, Col, Form, Row} from 'antd';
import PropTypes from 'prop-types';

import {
    accountCreationCheckBoxError,
    accountCreationConfirmation,
    accountCreationSelectBoxError,
    businessAccountCreationInstruction,
    personalAccountCreationInstruction
} from '../../helpers/text';

const AccountCreateTypes = ({
                                  selectPersonal,
                                  setSelectPersonal,
                                  selectBusiness,
                                  setSelectBusiness,
                                  handleFinish
                              }) => {
    const [checked, setChecked] = useState(false);
    const [showSelectCardError, setShowSelectCardError] = useState(false);
    const [showCheckBoxError, setShowCheckBoxError] = useState(false);

    const [form] = Form.useForm();

    const onFinish = () => {
        if (!checked) {
            setShowCheckBoxError(true);
        } else {
            setShowCheckBoxError(false);
        }
        if (!selectPersonal && !selectBusiness) {
            setShowSelectCardError(true);
        } else {
            setShowSelectCardError(false);
        }
        if (checked && (selectPersonal || selectBusiness)) {
            handleFinish();
        }
    }

    const onChange = (e) => {
        setChecked(e.target.checked);
    }

    const handleClickPersonal = () => {
        setSelectPersonal(true);
        setSelectBusiness(false);
    }

    const handleClickBusiness = () => {
        setSelectPersonal(false);
        setSelectBusiness(true);
    }

    return (
        <Form
            form={form}
            onFinish={onFinish}
            id="account-create-types"
            name="account-create-types"
        >
            <Row gutter={16}>
                <Col xs={24} sm={12} md={12}>
                    <Card
                        title={
                            <span className={selectPersonal ? "account-create-type-selected" : "account-create-type-unselected"}>
                                Personal
                            </span>
                        }
                        className={"details-card " + (selectPersonal ? "account-create-type-selected" : "account-create-type-unselected")}
                        bordered={true}
                    >
                        <Row className="account-create-type-description">{personalAccountCreationInstruction}</Row>
                        <Row justify="end" align="bottom">
                            <Button
                                onClick={handleClickPersonal}
                                className={selectPersonal ? "account-create-type-selected" : "account-create-type-unselected"}
                            >
                                {selectPersonal ? 'Selected' : 'Select'}
                            </Button>
                        </Row>
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={12}>
                    <Card
                        title={
                            <span className={selectBusiness ? "account-create-type-selected" : "account-create-type-unselected"}>
                                Business
                            </span>
                        }
                        className={"details-card " + (selectBusiness ? "account-create-type-selected" : "account-create-type-unselected")}
                        bordered={true}
                    >
                        <Row className="account-create-type-description">{businessAccountCreationInstruction}</Row>
                        <Row justify="end" align="bottom">
                            <Button
                                onClick={handleClickBusiness}
                                className={selectBusiness ? "account-create-type-selected" : "account-create-type-unselected"}
                            >
                                {selectBusiness ? 'Selected' : 'Select'}
                            </Button>
                        </Row>
                    </Card>
                </Col>
            </Row>
            {
                showSelectCardError && accountCreationSelectBoxError
            }
            <Checkbox
                checked={checked}
                onChange={onChange}
            >
                {accountCreationConfirmation}
            </Checkbox>
            {
                showCheckBoxError && accountCreationCheckBoxError
            }
        </Form>
    );
}

AccountCreateTypes.propTypes = {
    selectPersonal: PropTypes.bool.isRequired,
    setSelectPersonal: PropTypes.func.isRequired,
    selectBusiness: PropTypes.bool.isRequired,
    setSelectBusiness: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
};

export default AccountCreateTypes;